// extracted by mini-css-extract-plugin
export default {"root":"PaletteList_root__G0Kp-","container":"PaletteList_container__Vp4Am","nav":"PaletteList_nav__-RqfP","palettes":"PaletteList_palettes__Sthmb"};